import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './ExamMockTestFinish.styles';
import { ReactComponent as FinishIcon } from '@app/assets/icons/finish.svg';
import { useTranslation } from 'react-i18next';

export const ExamMockTestFinish: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mockTestId = queryParams.get('id');

  const handlGoToMockTest = () => {
    navigate(`/exam/mock-test?id=${mockTestId}`);
  };
  return (
    <>
      <S.Header>
        <p className="text-base">{t('page.mockTest.finish.header')}</p>
      </S.Header>
      <S.Wrapper>
        <FinishIcon />
        <p className="text-2xl font-bold">{t('page.mockTest.finish.title')}</p>
        <p className="text-base">
          {t('page.mockTest.finish.content')}
          <b>{t('page.mockTest.finish.content1')}</b>
        </p>
        <div className="flex gap-2">
          {/* <Button type="primary">Score</Button> */}
          <Button type="default" onClick={handlGoToMockTest}>
            {t('page.mockTest.button.returnMockTest')}
          </Button>
        </div>
      </S.Wrapper>
    </>
  );
};
